import * as React from 'react';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { ConnectChildren } from '@pec/aion-ui-core/types/connectChildren';
import { Error } from '../components/Error';
import { fetchServerTokensIfNeeded, registerServerTokens } from '@pec/aion-ui-core/actions/serverTokens';
import { IServerTokens } from '@pec/aion-ui-core/interfaces/serverTokens';
import { Loading } from '../components/Loading';
import { registerOrganizationIdInterceptor } from '@pec/aion-ui-core/helpers/interceptors';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { TimeZoneSyncer } from './TimeZoneSyncer';

type OwnProps = {
  organizationId?: string;
  serverTokens?: IServerTokens;
  ErrorComponent?: React.FC;
  LoadingComponent?: React.FC;
};

const mapStateToProps = ({ serverTokens: { serverTokens, error, isFetching } }: CommonRootState) => ({
  isAuthenticated: Boolean(serverTokens && serverTokens.accessToken && !isFetching),
  error
});

const mapDispatchToProps = (dispatch: ThunkDispatch<CommonRootState, null, RootActions>) => ({
  fetchServerTokensIfNeeded: () => dispatch(fetchServerTokensIfNeeded()),
  registerServerTokens: (serverTokens: IServerTokens) => dispatch(registerServerTokens(serverTokens))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps & ConnectChildren;

class RegisterInterceptorsContainer extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    const { organizationId, serverTokens, fetchServerTokensIfNeeded, registerServerTokens } = props;

    if (serverTokens) {
      registerServerTokens(serverTokens);
    } else {
      fetchServerTokensIfNeeded();
    }

    if (organizationId) {
      registerOrganizationIdInterceptor(organizationId);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { organizationId } = this.props;

    if (organizationId && organizationId !== prevProps.organizationId) {
      registerOrganizationIdInterceptor(organizationId);
    }
  }

  render() {
    const { error, isAuthenticated, children, ErrorComponent = Error, LoadingComponent = Loading } = this.props;
    return isAuthenticated ? (
      <>
        <TimeZoneSyncer />
        {children}
      </>
    ) : error ? (
      <ErrorComponent />
    ) : (
      <LoadingComponent />
    );
  }
}

export const RegisterInterceptors = connect(mapStateToProps, mapDispatchToProps)(RegisterInterceptorsContainer);
